export const SUBSCRIPTION_STATUS_ACTIVE = "ACTIVE";
export const SUBSCRIPTION_STATUS_PAYMENT_ERROR = "PAYMENT_ERROR";
export const SUBSCRIPTION_STATUS_PAYMENT_ATTEMPTS_EXCEEDED = "PAYMENT_ATTEMPTS_EXCEEDED";
export const SUBSCRIPTION_STATUS_PENDING_EXTERNAL_PAYMENT = "PENDING_EXTERNAL_PAYMENT";

export const SUBSCRIPTION_STATUS_WITH_ACCESS = [SUBSCRIPTION_STATUS_ACTIVE, SUBSCRIPTION_STATUS_PENDING_EXTERNAL_PAYMENT]
export const SUBSCRIPTION_STATUS_WITH_RESTRICTIONS = [SUBSCRIPTION_STATUS_PAYMENT_ERROR, SUBSCRIPTION_STATUS_PAYMENT_ATTEMPTS_EXCEEDED]
